module.exports = __webpack_public_path__ + "static/img/1.6143201.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/1.png
// module id = wAtf
// module chunks = 0